export default "__VITE_ASSET__76300ded__"